import React from "react";
import "./Environmental.css";
import Footer from "./Footer";
import img1 from "../assets/CDP_Rating.png";
import img2 from "../assets/Ecovadis.png";

function Environmental() {
    const cards = [
        {
            title: "Energy",
            icon: "⚡",
            desc: "Driving efficiency and maximizing renewable adoption.",
            points: [
                "ISO 50001 aligned energy management",
                "Continuous energy efficiency improvements (target: -10%)",
                "Increased renewable energy usage (target: 70%)",
                "Real-time energy monitoring across plants",
            ],
            highlight: true,
        },
        {
            title: "Water",
            icon: "💧",
            desc: "Optimizing water use through stewardship and digital control.",
            points: [
                "100% water monitoring and digital management",
                "-20% reduction in water consumption",
                "Aligned to ISO 46001 standards",
                "Reuse and recycling initiatives to minimize freshwater use",
            ],
        },
        {
            title: "Waste",
            icon: "♻️",
            desc: "Enabling circularity and responsible waste handling.",
            points: [
                "80% waste circularity target (hazardous & non-hazardous)",
                "100% hazardous waste sent for co-processing",
                "PR initiatives for plastics and oils",
                "Strong focus on waste reduction at source",
            ],
        },
        {
            title: "Effluents",
            icon: "🌊",
            desc: "Ensuring clean, compliant, and closed-loop operations.",
            points: [
                "Zero Liquid Discharge at TK & Oragadam",
                "75% reuse and recycling of treated water",
                "Advanced and alternative treatment technologies",
                "Rigorous compliance and monitoring systems",
            ],
        },
    ];

    return (
        <section id="what-we-offer">
            <section className="env-section">

                <div className="env-light-wrapper">
                    {/* LEFT CONTENT */}
                    <div className="prod-light-text">
                        <h3>
                            Environmental Sustainability at SCL
                        </h3>

                        <p><b>Zero Emission • Zero Water Discharge • Zero Waste Disposal</b></p>
                        <p style={{ margin: "10px 0 0 0" }}>We prioritize protecting the environment by embedding responsible practices into every stage of manufacturing. By optimizing energy use, reducing emissions, conserving water and managing waste responsibly, we continuously shrink our environmental footprint while improving operational efficiency.</p>
                    </div>

                    {/* RIGHT IMAGE / PLACEHOLDER */}
                    <div className="lightweighting-image">
                        <img src={require("../assets/sus-env.png")} alt="Solutions" />
                    </div>
                </div>

                
                <h2 className="env-title">Our Approach</h2>
                <div className="env-line"></div>
                <div className="env-grid-a">
                    <div className="env-card-a">
                        <img src={img1} alt="CDP Rating" />
                    </div>
                    <div className="env-card-a">
                        <img src={img2} alt="EcoVadis Sustainability Rating" />
                    </div>
                </div>
                <p style={{ fontSize: "18px" }}><b>Systems-led. Digitally monitored. People-driven.</b></p>
                <p style={{ textAlign: "center", margin: "20px 150px" }}>SCL integrates global standards, Industry 4.0 tools, and active employee engagement to drive environmental performance. These efforts are part of our long-term commitment to move steadily towards Scope 1 and Scope 2 Net Zero emissions by 2040, while remaining a responsible manufacturing partner for our customers worldwide.</p>
                <p style={{ textAlign: "center", margin: "20px 150px 60px 150px" }}>SCL is committed to transparent and responsible sustainability practices. We have achieved CDP Climate: B, CDP Water: B, and an EcoVadis Sustainability Rating – Jan 2025.</p>

                <div className="env-grid">
                    {cards.map((card, index) => (
                        <div key={index} className="env-box">
                            <h3><span className="env-icon">{card.icon}</span> {card.title}</h3>
                            <p className="env-desc">{card.desc}</p>

                            <ul>
                                {card.points.map((point, i) => (
                                    <li key={i}>{point}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </section>
            <Footer />
        </section>
    );
}

export default Environmental;
